import { LAYOUTS, } from '@voltmoney/types';
import { FontSizeTokens, IconSizeTokens, IconTokens, StackAlignItems, StackHeight, StackJustifyContent, StackType, StackWidth, WIDGET, } from "@voltmoney/schema";
import { ROUTE } from "../../../routes";
export const template = async () => {
    return {
        layout: {
            id: ROUTE.PAYMENT_LOADER,
            type: LAYOUTS.LIST,
            widgets: [
                {
                    id: "containerStack", type: WIDGET.STACK
                }
            ],
        },
        datastore: {
            containerStack: {
                type: StackType.column,
                width: StackWidth.FULL,
                height: StackHeight.FULL,
                justifyContent: StackJustifyContent.center,
                alignItems: StackAlignItems.center,
                widgetItems: [
                    { id: "loaderIcon", type: WIDGET.ICON },
                    { id: "loaderText", type: WIDGET.TEXT },
                ]
            },
            loaderIcon: {
                name: IconTokens.Pending,
                size: IconSizeTokens.XXXXXXXXL,
            },
            loaderText: {
                label: 'Loading... Please wait',
                fontSize: FontSizeTokens.LG,
            }
        },
    };
};
export const paymentLoader = {
    onLoad: async () => {
        return Promise.resolve(template());
    },
    clearPrevious: true,
};
